import { accordionInit } from "../lib/accordion.js";
import { onDocumentLoaded } from "../utils/on-document-loaded.js";
import { servicesSlider } from "../modules/prices/services-slider.js";
import { modulesCalc } from "../modules/prices/modules.js";

onDocumentLoaded(() => {
    console.log("[prices-page.js inited]");
    accordionInit();
    servicesSlider();
    modulesCalc();
});